import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, DialogTitle, Grid, Box, Typography, useMediaQuery, useTheme, Drawer } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from './addcase.module.scss';
import ButtonLink from './ButtonLink';
import 'src/style.css';
import { setGlobalState, useGlobalState } from 'src/state/globalstate';
// import AdvanceSearch from './Advance-basic';
import { toast } from 'react-toastify';
import { eDiscoveryUrl } from 'src/common/routes';

function HeaderMenu() {
  let navigate = useNavigate();
  const [languageArray] = useGlobalState('languageArray');
  const [selectedTab, setselectedTab] = useState<number>(0);
  const [headerMenu] = useGlobalState('headerMenu');
  const email = localStorage.getItem('email');
  const [smartSerachAccessEmails] = useGlobalState('smartSerachAccessEmails');
  const [showSmartSearch, setshowSmartSearch] = useState(false);
  const location = useLocation();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const RefreshDashboard = () => {
    setGlobalState('ErrorFoundGlobal', true);
    setselectedTab(0);
    navigate(eDiscoveryUrl.CaseS3 + '/1');
  };

  const OpenRules = () => {
    setselectedTab(1);
    navigate(eDiscoveryUrl.Rules);
  };

  const OpenEditorialClaims = () => {
    setselectedTab(2);
    navigate(eDiscoveryUrl.EditorialClaims);
  };

  const OpenSmartSearch = () => {
    setselectedTab(3);
    navigate(eDiscoveryUrl.Chatbot);
  };

  const OpenClaimsDetails = () => {
    setselectedTab(4);
    navigate(eDiscoveryUrl.ClaimsDetail);
  };

  const OpenSemanticClaims = () => {
    setselectedTab(5);
    navigate(eDiscoveryUrl.SemanticClaims);
  };

  useEffect(() => {
    // show smart search only when the user's email is allowed
    if (smartSerachAccessEmails && smartSerachAccessEmails.length > 0 && email) {
      setshowSmartSearch(smartSerachAccessEmails.includes(email));
    } else {
      setshowSmartSearch(false);
    }
  }, [smartSerachAccessEmails, email]);

  useEffect(() => {
    // set selected tab based on current pathname; runs when location changes
    const path = location.pathname || '';

    if (
      path.includes('dashboard/folder/') ||
      path.includes('/views/') ||
      path.includes('/views-new/')
    ) {
      setselectedTab(0);
    } else if (path.includes('/rules')) {
      setselectedTab(1);
    } else if (path.includes('editorial-guideline')) {
      setselectedTab(2);
    } else if (path.includes('smart-search')) {
      setselectedTab(3);
    } else if (path.includes('claims-detail')) {
      setselectedTab(4);
    } else if (path.includes('semantic-claims')) {
      setselectedTab(5);
    } else if (path.includes('letter-search')) {
      setselectedTab(6);
    } else if (path.includes('irs')) {
      setselectedTab(7);
    } else {
      // default: no selection
      setselectedTab(-1);
    }
  }, [location.pathname, headerMenu]);

  // if (headerMenu) {
  //   setselectedTab(headerMenu);
  // }
  const OpenLetterSearch = () => {
    setselectedTab(6);
    navigate(eDiscoveryUrl.letterSearch);
  };

  const OpenSmartSearchNew = () => {
    setselectedTab(7);
    navigate(eDiscoveryUrl.SmartSearchNew);
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="stretch"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          pl: { xs: 1, sm: 2 },
          pr: { xs: 1, sm: 2 }
        }}
      >
        {/* Mobile hamburger */}
          <Grid item xs={12} sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-start' }}>
            <IconButton size="small" onClick={() => setDrawerOpen(true)} aria-label="Open menu">
              <MenuIcon />
            </IconButton>
          </Grid>
        <Grid item xs={12}>
          {/* Desktop inline menu; hidden on xs because mobile uses drawer */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
            <Typography
              component="button"
              onClick={RefreshDashboard}
              sx={{
                background: 'transparent',
                border: 0,
                textAlign: 'left',
                cursor: 'pointer',
              }}
              className={selectedTab === 0 ? styles.menuItemLabelActive : styles.menuItemLabel}
            >
              {languageArray && languageArray.length > 0 ? languageArray[7] : 'Documents'}
            </Typography>

            <Typography
              component="button"
              onClick={OpenRules}
              sx={{
                background: 'transparent',
                border: 0,
                textAlign: 'left',
                cursor: 'pointer',
              }}
              className={selectedTab === 1 ? styles.menuItemLabelActive : styles.menuItemLabel}
            >
              {languageArray && languageArray.length > 0 ? languageArray[223] : 'Claims dictionary'}
            </Typography>

            <Typography
              component="button"
              onClick={OpenEditorialClaims}
              sx={{
                background: 'transparent',
                border: 0,
                textAlign: 'left',
                cursor: 'pointer',
              }}
              className={selectedTab === 2 ? styles.menuItemLabelActive : styles.menuItemLabel}
            >
              Editorial Guideline
            </Typography>

            {showSmartSearch && (
              <Typography
                component="button"
                onClick={OpenSmartSearch}
                sx={{
                  background: 'transparent',
                  border: 0,
                  textAlign: 'left',
                  cursor: 'pointer'
                }}
                className={selectedTab === 3 ? styles.menuItemLabelActive : styles.menuItemLabel}
              >
                Smart Search
              </Typography>
            )}

            <Typography
              component="button"
              onClick={OpenLetterSearch}
              sx={{
                background: 'transparent',
                border: 0,
                textAlign: 'left',
                cursor: 'pointer',
              }}
              className={selectedTab === 6 ? styles.menuItemLabelActive : styles.menuItemLabel}
            >
              US Letter Search
            </Typography>

            <Typography
              component="button"
              onClick={OpenSmartSearchNew}
              sx={{
                background: 'transparent',
                border: 0,
                textAlign: 'left',
                cursor: 'pointer',
              }}
              className={selectedTab === 7 ? styles.menuItemLabelActive : styles.menuItemLabel}
            >
              IRS
            </Typography>

          </Box>
        </Grid>
      </Grid>

      {/* Drawer for mobile */}
      <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 260, p: 2 }} role="presentation">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Menu</Typography>
            <IconButton size="small" onClick={() => setDrawerOpen(false)} aria-label="Close menu">
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <ButtonLink label={languageArray && languageArray.length > 0 ? languageArray[7] : 'Documents'} active={selectedTab === 0} onClick={() => { RefreshDashboard(); setDrawerOpen(false); }} />
            <ButtonLink label={languageArray && languageArray.length > 0 ? languageArray[223] : 'Claims dictionary'} active={selectedTab === 1} onClick={() => { OpenRules(); setDrawerOpen(false); }} />
            <ButtonLink label={'Editorial Guideline'} active={selectedTab === 2} onClick={() => { OpenEditorialClaims(); setDrawerOpen(false); }} />
            {showSmartSearch && <ButtonLink label={'Smart Search'} active={selectedTab === 3} onClick={() => { OpenSmartSearch(); setDrawerOpen(false); }} />}
            <ButtonLink label={'US Letter Search'} active={selectedTab === 6} onClick={() => { OpenLetterSearch(); setDrawerOpen(false); }} />
            <ButtonLink label={'IRS'} active={selectedTab === 7} onClick={() => { OpenSmartSearchNew(); setDrawerOpen(false); }} />
          </Box>
        </Box>
      </Drawer>
    </>
  );
}

export default HeaderMenu;
